export enum DefaultEndpointKitNodeDisplay {
  x1 = -70,
  y1 = -10,
}
